import React, { useRef, useState } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';
import './style/TextSequence.css'

gsap.registerPlugin(ScrollTrigger);

const storyLines = [
    "نحن في SASKE نقدم كل ما هو جديد",
    "نهندس حلولاً مخصصة لتناسب أعمالك و إحتياجاتك الخاصه.",
    "كل سطر كود يكتبه مهندسون بخبرات تمتد لعشرات السنين.",
    "بنية تحتية مرنة، حماية قصوى، وأداء خارق.",
    "ابدأ رحلتك التقنية معنا اليوم و تألق."
];

const TextSequence = () => {
    const containerRef = useRef(null);
    const moverRef = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const intervalsRef = useRef({});

    // ==========================================
    // 🎛️ لوحة التحكم الرئيسية (مفاتيح الأنميشن والمسافات)
    // ==========================================
    const LINE_HEIGHT = 50;       // 📏 المسافة بين السطور (ارتفاع السطر الواحد بالبكسل)
    const SCROLL_SPEED = 1000;    // ⏱️ بطء وسرعة السكرول الإجمالي (كل ما زاد، السكرول بقى أبطأ وأفخم)
    const SCRAMBLE_SPEED = 60;    // ⚡ سرعة تفكيك التشفير (رقم أقل = أسرع)
    // ==========================================

    const scrambleElement = (element, targetText, speed = SCRAMBLE_SPEED) => {
        const letters = "!<>-_\\/[]{}—=+*^?#________0123456789";
        let iterations = 0;
        if (intervalsRef.current[targetText]) clearInterval(intervalsRef.current[targetText]);

        intervalsRef.current[targetText] = setInterval(() => {
            element.innerText = targetText
                .split("")
                .map((letter, index) => {
                    if (letter === " ") return " ";
                    if (index < iterations) return targetText[index];
                    return letters[Math.floor(Math.random() * letters.length)];
                })
                .join("");

            if (iterations >= targetText.length) clearInterval(intervalsRef.current[targetText]);
            iterations += 1;
        }, speed);
    };

    useGSAP(() => {
        const linesElements = gsap.utils.toArray('.sequence-line');
        
        // 1. إنشاء التايم لاين الأب المثبت
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: containerRef.current,
                start: "top top",
                end: `+=${storyLines.length * SCROLL_SPEED}`, // التحكم في المسافة الكلية للسكرول
                pin: true,
                scrub: 1,
                onUpdate: (self) => {
                    const progress = self.progress;
                    const index = Math.min(
                        Math.floor(progress * storyLines.length),
                        storyLines.length - 1
                    );
                    setActiveIndex(index);
                }
            }
        });

        // 2. بناء الأنميشن المتساوي بالتوالي
        storyLines.forEach((line, index) => {
            if (index === 0) {
                // السطر الأول يظهر فوراً عند التثبيت
                tl.to({}, {
                    duration: 1, // الـ duration هنا متساوي لضمان توزيع مسافة السكرول بالعدل
                    onStart: () => {
                        if (linesElements[0] && linesElements[0].innerText === "") {
                            scrambleElement(linesElements[0], storyLines[0]);
                        }
                    }
                });
            } else {
                // 🎯 التحكم في المسافة: صعود الحاوية بدقة بناءً على الـ LINE_HEIGHT
                // 🎯 التحكم في وقت الظهور: كل خطوة تأخذ duration: 1 بالتساوي لتوزيع بكسلات السكرول
                tl.to(moverRef.current, {
                    y: -(index * LINE_HEIGHT), // المسافة الرياضية الصحيحة للصعود للسطر التالي
                    duration: 1,
                    ease: "power1.inOut",
                    onStart: () => {
                        if (linesElements[index]) {
                            scrambleElement(linesElements[index], storyLines[index]);
                        }
                    },
                    onReverseComplete: () => {
                        if (linesElements[index - 1]) {
                            scrambleElement(linesElements[index - 1], storyLines[index - 1]);
                        }
                    }
                });
            }
        });

    }, { scope: containerRef });

    return (
        <div ref={containerRef} className="sequence-container" style={{ height: '100vh', background: '#0b0c10', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {/* جعل الفيو بورت يركز فقط على السطر النشط حالياً ويخفي الباقي أو يظهرهم حسب الـ CSS */}
            <div className="sequence-viewport" style={{ height: `${LINE_HEIGHT}px`, overflow: 'visible', position: 'relative' }}>
                <ul ref={moverRef} className="sequence-mover" style={{ listStyle: 'none', padding: 0, margin: 0, transform: 'translateY(0)' }}>
                    {storyLines.map((line, index) => (
                        <li 
                            key={index} 
                            className={`sequence-line ${index === activeIndex ? 'line-active' : ''}`}
                            style={{
                                height: `${LINE_HEIGHT}px`,
                                lineHeight: `${LINE_HEIGHT}px`,
                                color: index === activeIndex ? '#6366f1' : 'rgba(255, 255, 255, 0)',
                                textAlign: 'center',
                                fontFamily: 'monospace',
                                transition: 'color 0.4s, transform 0.4s',
                                transform: index === activeIndex ? 'scale(1.05)' : 'scale(1)'
                            }}
                        >
                            {/* سيتم الحقن ديناميكياً بواسطة الجافاسكريبت والـ Scramble */}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default TextSequence;